import styled from 'styled-components';

export const HelpButtonStyled = styled.button`
  outline: none;
  border: none;
  background: transparent;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #1d201f;
  display: flex;
  align-items: center;

  ion-icon {
    font-size: 30px;
  }
`;
